export enum Role {
    None = 0,
    President = 1,
    ResponsableLocation = 2,
    Caissier = 3,
    Secretaire = 4,
    ResponsableManif = 5,
    Gardien = 6
}

export function getRole(s: string): Role {
    switch (s) {
        case "1":
            return Role.President;
        case "2":
            return Role.ResponsableLocation;
        case "3":
            return Role.Caissier;
        case "4":
            return Role.Secretaire;
        case "5":
            return Role.ResponsableManif;
        case "6":
            return Role.Gardien;
        default:
            return Role.President;
            break;
    }
}



// WEBPACK FOOTER //
// ./src/app/framework/user/Role.ts